import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ApidataService } from '../services/apidata.service';
import { NumberListResp, OpTypeResp } from '../enums/apiResponse';
import { RespCode, SessionVar } from '../enums/emums';
import { ApiService } from '../services/apiservices.service';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
// import { SidebarComponent } from "../sidebar/sidebar.component";
// import { FooterComponent } from "../footer/footer.component";

@Component({
  selector: 'aditya-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.css'],
  // imports: [SidebarComponent, FooterComponent]
})
export class ContentComponent implements OnInit {
  IsContentLoaded = false;
  isUserRoutes = false;
  BaseData: NumberListResp;
  OpTypes: OpTypeResp;
  constructor(private apiData: ApidataService, private cookie: CookieService,
    private router: Router, private cdr: ChangeDetectorRef,
    private apiServices: ApiService) { }

  ngOnInit() {
    const url = this.router.url.split('/');
    if (url[url.length - 2] === 'user') {
      this.isUserRoutes = true;
      // this.cdr.detectChanges();
    }
    this.apiData.LoaderToggle();
    var isLocal = localStorage.getItem(SessionVar.BaseData);
    if (!this.cookie.check(SessionVar.BaseData)) {
      localStorage.removeItem(SessionVar.BaseData);
      isLocal = null;
    }
    if (this.apiData.getSessionData(SessionVar.BaseData)) {
      this.IsContentLoaded = true;
      this.apiData.LoaderToggle();
    }
    else if (isLocal) {
      this.BaseData = JSON.parse(localStorage.getItem(SessionVar.BaseData));
      this.apiData.setSessionData(SessionVar.BaseData, this.BaseData);
      this.OpTypes = JSON.parse(localStorage.getItem(SessionVar.OperatorList));
      this.apiData.setSessionData(SessionVar.OperatorList, this.OpTypes);
      if (this.apiData.getSessionData(SessionVar.BaseData)) {
        this.IsContentLoaded = true;
        this.apiData.LoaderToggle();
      }
    }
    else {
      this.apiServices.GetNumberList().subscribe(resp => {
        this.BaseData = resp;
        if (this.BaseData != undefined) {
          if (this.BaseData.statuscode == RespCode.Success) {
            this.apiData.setSessionData(SessionVar.BaseData, this.BaseData.data);
            localStorage.setItem(SessionVar.BaseData, JSON.stringify(this.BaseData.data));
            var date = new Date();
            var minutes = 1440
            date.setTime(date.getTime() + (minutes * 60 * 1000));
            this.cookie.set(SessionVar.BaseData, SessionVar.BaseData, date);
            this.GetOptypes();
            this.IsContentLoaded = true;
          }
        }

        this.apiData.LoaderToggle();

      })
    }
  }
  scriptId = 'kt-scripts-bundle';

  ngAfterViewInit(): void {
    this.reloadKTScripts();
  }

  reloadKTScripts(): void {
    const existingScript = document.getElementById(this.scriptId);
    if (existingScript) {
      existingScript.remove(); // Remove the old script
    }

    const script = document.createElement('script');
    script.id = this.scriptId;
    script.src = 'assets/js/scripts.bundle.js';
    script.type = 'text/javascript';
    script.async = false;

    script.onload = () => {
      // Optionally reinitialize sidebar or KT components here
      this.initKTComponents();
    };

    document.body.appendChild(script);
  }

  initKTComponents(): void {
    // Remove any existing overlays before reinitializing
    const existingOverlays = document.querySelectorAll('.drawer-overlay');
    existingOverlays.forEach(overlay => overlay.remove());
    const sidebarElement = document.querySelector('#kt_sidebar_id');
    if (sidebarElement && (window as any).KTDrawer) {
      const existingInstance = (window as any).KTDrawer.getInstance(sidebarElement);
      if (existingInstance && existingInstance.destroy) {
        existingInstance.destroy();
      }
      new (window as any).KTDrawer(sidebarElement);
    }
  }

  // initKTComponents(): void {
  //   const sidebarElement = document.querySelector('#kt_app_sidebar');
  //   if (sidebarElement && (window as any).KTDrawer) {
  //     const existingInstance = (window as any).KTDrawer.getInstance(sidebarElement);
  //     if (existingInstance && existingInstance.destroy) {
  //       existingInstance.destroy();
  //     }
  //     new (window as any).KTDrawer(sidebarElement);
  //   }
  // }

  GetOptypes() {
    this.apiServices.GetOpTypes().subscribe(resp => {
      this.OpTypes = resp;
      if (this.OpTypes != undefined) {
        if (this.OpTypes.statuscode == RespCode.Success) {
          this.apiData.setSessionData(SessionVar.OperatorList, this.OpTypes.data);
          localStorage.setItem(SessionVar.OperatorList, JSON.stringify(this.OpTypes.data));
          var date = new Date();
          var minutes = 1440
          date.setTime(date.getTime() + (minutes * 60 * 1000));
          this.cookie.set(SessionVar.OperatorList, SessionVar.OperatorList, date);
        }
      }
    })
  }
}
